"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var att_animate_1 = require("../att-animate");
var anim_values_1 = require("../models/anim-values");
var anim_types_1 = require("../models/anim-types");
var CommonAnims = /** @class */ (function () {
    function CommonAnims(animationOnElem, autoplay) {
        if (animationOnElem === void 0) { animationOnElem = ''; }
        if (autoplay === void 0) { autoplay = false; }
        this.autoplay = false;
        this.animationOnElem = animationOnElem;
        this.autoplay = autoplay;
    }
    CommonAnims.prototype.returnAnimState = function (anim) {
        // if (this.autoplay) {
        return anim.play();
        // }
        // return anim;
    };
    // element collapses
    CommonAnims.prototype.collapse = function (options, panelCollapse) {
        var animSettings;
        // Set default options if no default options passed in
        if (!options) {
            options = {
                animSettings: {},
                childOnElem: '',
            };
        }
        if (!options.childOnElem) {
            options.childOnElem = '';
        }
        if (!options.animSettings) {
            animSettings = {
                fadeOut: { duration: 300 },
                scale: { duration: 400 },
                transformOrigin: (panelCollapse ? anim_values_1.TransformOrigin.TOP_MIDDLE : anim_values_1.TransformOrigin.BOTTOM_LEFT),
            };
        }
        else {
            animSettings = Object.assign({}, {
                fadeOut: { duration: 300 },
                scale: { duration: 400 },
                transformOrigin: (panelCollapse ? anim_values_1.TransformOrigin.TOP_MIDDLE : anim_values_1.TransformOrigin.BOTTOM_LEFT),
            }, options.animSettings);
        }
        // Begin Animations
        var anim = new att_animate_1.ATTAnimate();
        if (options.childOnElem && options.affectChildNodes) {
            // fade-out
            anim
                .addAnim({
                animTypes: [
                    anim_types_1.default.custom({
                        opacity: [1, 0],
                    })
                ],
                animationDuration: animSettings.fadeOut.duration,
                animationOnElem: options.childOnElem || this.animationOnElem,
            })
                // scale
                .addAnim({
                animTypes: [
                    anim_types_1.default.custom(panelCollapse ? { scaleY: [1, 0] } : { scale: [1, 0] }),
                    anim_types_1.default.setTransformOrigin(animSettings.transformOrigin ||
                        (panelCollapse ? anim_values_1.TransformOrigin.CENTER_MIDDLE : anim_values_1.TransformOrigin.BOTTOM_LEFT)),
                ],
                animationDuration: animSettings.scale.duration,
                animationOnElem: this.animationOnElem,
                offset: 300,
            });
        }
        else {
            // scale
            anim
                .addAnim({
                animTypes: [
                    anim_types_1.default.custom(panelCollapse ? { scaleY: [1, 0] } : { scale: [1, 0] }),
                    anim_types_1.default.setTransformOrigin(animSettings.transformOrigin ||
                        (panelCollapse ? anim_values_1.TransformOrigin.CENTER_MIDDLE : anim_values_1.TransformOrigin.BOTTOM_LEFT)),
                ],
                animationDuration: animSettings.scale.duration,
                animationOnElem: this.animationOnElem,
                offset: 300,
            });
        }
        return this.returnAnimState(anim);
    };
    // element collapses
    CommonAnims.prototype.collapsePanel = function (options) {
        return this.collapse(options, true);
    };
    // element opens
    CommonAnims.prototype.expand = function (options, expandPanel) {
        if (!options) {
            options = {
                animSettings: {},
                childOnElem: '',
            };
        }
        if (!options.childOnElem) {
            options.childOnElem = '';
        }
        if (!options.animSettings) {
            options.animSettings = {
                fadeOut: { duration: 300 },
                scale: { duration: 400 },
                transformOrigin: (expandPanel ? anim_values_1.TransformOrigin.TOP_MIDDLE : anim_values_1.TransformOrigin.BOTTOM_LEFT),
            };
        }
        var anim = new att_animate_1.ATTAnimate();
        if (options.childOnElem && options.affectChildNodes) {
            anim
                // Scale
                .addAnim({
                animTypes: [
                    anim_types_1.default.custom({
                        opacity: [0, 0],
                    }),
                ],
                animationDuration: 300,
                animationOnElem: options.childOnElem,
            })
                .addAnim({
                animTypes: [
                    anim_types_1.default.resetVisibility(),
                    anim_types_1.default.custom(expandPanel ? { scaleY: [0, 1] } : { scale: [0, 1] }),
                    anim_types_1.default.setTransformOrigin(options.animSettings.transformOrigin
                        || (expandPanel ? anim_values_1.TransformOrigin.TOP_MIDDLE : anim_values_1.TransformOrigin.BOTTOM_LEFT)),
                ],
                animationDuration: 200,
                animationOnElem: this.animationOnElem,
                offset: 0,
            })
                .addAnim({
                animTypes: [
                    anim_types_1.default.custom({
                        opacity: [0, 0],
                    }),
                ],
                animationDuration: 300,
                animationOnElem: options.childOnElem,
                offset: 0,
            })
                // Fade-In
                .addAnim({
                animTypes: [
                    anim_types_1.default.custom({
                        opacity: [0, 1],
                    }),
                ],
                animationDuration: 500,
                animationOnElem: options.childOnElem,
                offset: options.childOnElem ? 300 : 0,
            });
        }
        else {
            anim
                // Scale
                .addAnim({
                animTypes: [
                    anim_types_1.default.resetVisibility(),
                    anim_types_1.default.custom(expandPanel ? { scaleY: [0, 1] } : { scale: [0, 1] }),
                    anim_types_1.default.setTransformOrigin(options.animSettings.transformOrigin
                        || (expandPanel ? anim_values_1.TransformOrigin.TOP_MIDDLE : anim_values_1.TransformOrigin.BOTTOM_LEFT)),
                ],
                animationDuration: 400,
                animationOnElem: this.animationOnElem,
            });
        }
        return this.returnAnimState(anim);
    };
    // element starts at a left offset of "xPos" and slides in to normal position
    CommonAnims.prototype.slideFromLeft = function (options) {
        if (!options) {
            options = {
                animSettings: {},
                childOnElem: '',
            };
        }
        if (!options.childOnElem) {
            options.childOnElem = '';
        }
        if (!options.animSettings) {
            options.animSettings = {
                duration: anim_values_1.AnimSpeed.MEDIUM,
                transformOrigin: anim_values_1.TransformOrigin.CENTER_MIDDLE,
                xPos: 800,
            };
        }
        var anim = new att_animate_1.ATTAnimate()
            .addAnim({
            animTypes: [
                anim_types_1.default.resetVisibility(),
                anim_types_1.default.slideFromLeft(options.animSettings.xPos),
            ],
            animationDuration: options.animSettings.duration || anim_values_1.AnimSpeed.MEDIUM,
            animationOnElem: this.animationOnElem,
        })
            .addAnim({
            animTypes: [anim_types_1.default.fadeIn()],
            animationDuration: options.animSettings.duration,
            animationOnElem: options.childOnElem || this.animationOnElem,
        });
        return this.returnAnimState(anim);
    };
    // element starts from its default position and slides to the left
    CommonAnims.prototype.slideToLeft = function (options) {
        if (!options) {
            options = {
                animSettings: {},
                childOnElem: '',
            };
        }
        if (!options.childOnElem) {
            options.childOnElem = '';
        }
        if (!options.animSettings) {
            options.animSettings = {
                duration: anim_values_1.AnimSpeed.MEDIUM,
                transformOrigin: anim_values_1.TransformOrigin.CENTER_MIDDLE,
                xPos: 800,
            };
        }
        var anim = new att_animate_1.ATTAnimate()
            .addAnim({
            animTypes: [
                anim_types_1.default.slideToLeft(options.animSettings.xPos),
            ],
            animationDuration: options.animSettings.duration || anim_values_1.AnimSpeed.MEDIUM,
            animationOnElem: this.animationOnElem,
        })
            .addAnim({
            animTypes: [anim_types_1.default.fadeOut()],
            animationDuration: options.animSettings.duration || anim_values_1.AnimSpeed.MEDIUM,
            animationOnElem: options.childOnElem || this.animationOnElem,
        });
        return this.returnAnimState(anim);
    };
    // element starts from its default position and slides to the right
    CommonAnims.prototype.slideFromRight = function (options) {
        if (!options) {
            options = {
                animSettings: {},
                childOnElem: '',
            };
        }
        if (!options.childOnElem) {
            options.childOnElem = '';
        }
        if (!options.animSettings) {
            options.animSettings = {
                duration: anim_values_1.AnimSpeed.MEDIUM,
                transformOrigin: anim_values_1.TransformOrigin.CENTER_MIDDLE,
                xPos: 800,
            };
        }
        var anim = new att_animate_1.ATTAnimate()
            .addAnim({
            animTypes: [
                anim_types_1.default.resetVisibility(),
                anim_types_1.default.slideFromRight(options.animSettings.xPos || 800),
            ],
            animationDuration: options.animSettings.duration || anim_values_1.AnimSpeed.MEDIUM,
            animationOnElem: this.animationOnElem,
        })
            .addAnim({
            animTypes: [anim_types_1.default.fadeIn()],
            animationDuration: options.animSettings.duration || anim_values_1.AnimSpeed.MEDIUM,
            animationOnElem: options.childOnElem || this.animationOnElem,
        });
        return this.returnAnimState(anim);
    };
    // element starts from its default position and slides to the right
    CommonAnims.prototype.slideToRight = function (options) {
        if (!options) {
            options = {
                animSettings: {},
                childOnElem: '',
            };
        }
        if (!options.childOnElem) {
            options.childOnElem = '';
        }
        if (!options.animSettings) {
            options.animSettings = {
                duration: anim_values_1.AnimSpeed.MEDIUM,
                transformOrigin: anim_values_1.TransformOrigin.CENTER_MIDDLE,
                xPos: 800,
            };
        }
        var anim = new att_animate_1.ATTAnimate()
            .addAnim({
            animTypes: [anim_types_1.default.slideToRight(options.animSettings.xPos || 800)],
            animationDuration: options.animSettings.duration || anim_values_1.AnimSpeed.MEDIUM,
            animationOnElem: this.animationOnElem,
        })
            .addAnim({
            animTypes: [anim_types_1.default.fadeOut()],
            animationDuration: options.animSettings.duration || anim_values_1.AnimSpeed.MEDIUM,
            animationOnElem: options.childOnElem || this.animationOnElem,
        });
        return this.returnAnimState(anim);
    };
    // element starts from top of the screen and slides down to default position
    CommonAnims.prototype.slideFromTop = function (options) {
        if (!options) {
            options = {
                animSettings: {},
                childOnElem: '',
            };
        }
        if (!options.childOnElem) {
            options.childOnElem = '';
        }
        if (!options.animSettings) {
            options.animSettings = {
                duration: anim_values_1.AnimSpeed.MEDIUM,
                transformOrigin: anim_values_1.TransformOrigin.CENTER_MIDDLE,
                yPos: 800,
            };
        }
        var anim = new att_animate_1.ATTAnimate()
            .addAnim({
            animTypes: [
                anim_types_1.default.resetVisibility(),
                anim_types_1.default.slideFromTop(options.animSettings.yPos || 800),
            ],
            animationDuration: options.animSettings.duration || anim_values_1.AnimSpeed.MEDIUM,
            animationOnElem: this.animationOnElem,
        })
            .addAnim({
            animTypes: [anim_types_1.default.fadeIn()],
            animationDuration: options.animSettings.duration || anim_values_1.AnimSpeed.MEDIUM,
            animationOnElem: options.childOnElem || this.animationOnElem,
        });
        return this.returnAnimState(anim);
    };
    // element starts at normal position and slides up 'yPos' pixels
    CommonAnims.prototype.slideToTop = function (options) {
        if (!options) {
            options = {
                animSettings: {},
                childOnElem: '',
            };
        }
        if (!options.childOnElem) {
            options.childOnElem = '';
        }
        if (!options.animSettings) {
            options.animSettings = {
                duration: anim_values_1.AnimSpeed.MEDIUM,
                transformOrigin: anim_values_1.TransformOrigin.CENTER_MIDDLE,
                yPos: 800,
            };
        }
        var anim = new att_animate_1.ATTAnimate()
            .addAnim({
            animTypes: [anim_types_1.default.slideToTop(options.animSettings.yPos || 800)],
            animationDuration: options.animSettings.duration || anim_values_1.AnimSpeed.MEDIUM,
            animationOnElem: this.animationOnElem,
        })
            .addAnim({
            animTypes: [anim_types_1.default.fadeOut()],
            animationDuration: options.animSettings.duration || anim_values_1.AnimSpeed.MEDIUM,
            animationOnElem: options.childOnElem || this.animationOnElem,
        });
        return this.returnAnimState(anim);
    };
    // element starts from an offset of yPos and slides up to default position
    CommonAnims.prototype.slideFromBottom = function (options) {
        if (!options) {
            options = {
                animSettings: {},
                childOnElem: '',
            };
        }
        if (!options.childOnElem) {
            options.childOnElem = '';
        }
        if (!options.animSettings) {
            options.animSettings = {
                duration: anim_values_1.AnimSpeed.MEDIUM,
                transformOrigin: anim_values_1.TransformOrigin.CENTER_MIDDLE,
                yPos: 800,
            };
        }
        var anim = new att_animate_1.ATTAnimate()
            .addAnim({
            animTypes: [
                anim_types_1.default.resetVisibility(),
                anim_types_1.default.slideFromBottom(options.animSettings.yPos || 800),
            ],
            animationDuration: options.animSettings.duration || anim_values_1.AnimSpeed.MEDIUM,
            animationOnElem: this.animationOnElem,
        })
            .addAnim({
            animTypes: [anim_types_1.default.fadeIn()],
            animationDuration: options.animSettings.duration || anim_values_1.AnimSpeed.MEDIUM,
            animationOnElem: options.childOnElem || this.animationOnElem,
        });
        return this.returnAnimState(anim);
    };
    // animation starts from current position and slides down 'yPos' number of pixels
    CommonAnims.prototype.slideToBottom = function (options) {
        if (!options) {
            options = {
                animSettings: {},
                childOnElem: '',
            };
        }
        if (!options.childOnElem) {
            options.childOnElem = '';
        }
        if (!options.animSettings) {
            options.animSettings = {
                duration: anim_values_1.AnimSpeed.MEDIUM,
                transformOrigin: anim_values_1.TransformOrigin.CENTER_MIDDLE,
                yPos: 800,
            };
        }
        var anim = new att_animate_1.ATTAnimate()
            .addAnim({
            animTypes: [anim_types_1.default.slideToBottom(options.animSettings.yPos || 800)],
            animationDuration: options.animSettings.duration || anim_values_1.AnimSpeed.MEDIUM,
            animationOnElem: this.animationOnElem,
        })
            .addAnim({
            animTypes: [anim_types_1.default.fadeOut()],
            animationDuration: options.animSettings.duration || anim_values_1.AnimSpeed.MEDIUM,
            animationOnElem: options.childOnElem || this.animationOnElem,
        });
        return this.returnAnimState(anim);
    };
    // Animation fades-in
    CommonAnims.prototype.fadeIn = function (options) {
        if (!options) {
            options = {
                animSettings: {},
                childOnElem: '',
            };
        }
        if (!options.childOnElem) {
            options.childOnElem = '';
        }
        if (!options.animSettings) {
            options.animSettings = {
                duration: 300,
            };
        }
        var anim = new att_animate_1.ATTAnimate()
            .addAnim({
            animTypes: [anim_types_1.default.fadeIn()],
            animationDuration: 250 || options.animSettings.duration || anim_values_1.AnimSpeed.MEDIUM,
            animationOnElem: this.animationOnElem,
        });
        return this.returnAnimState(anim);
    };
    // Animation fades-out
    CommonAnims.prototype.fadeOut = function (options) {
        if (!options) {
            options = {
                animSettings: {},
                childOnElem: '',
            };
        }
        if (!options.childOnElem) {
            options.childOnElem = '';
        }
        if (!options.animSettings) {
            options.animSettings = {
                duration: anim_values_1.AnimSpeed.MEDIUM,
            };
        }
        var anim = new att_animate_1.ATTAnimate()
            .addAnim({
            animTypes: [anim_types_1.default.fadeOut()],
            animationDuration: 800 || options.animSettings.duration || anim_values_1.AnimSpeed.MEDIUM,
            animationOnElem: this.animationOnElem,
        });
        return this.returnAnimState(anim);
    };
    // Animation scales from number to number
    CommonAnims.prototype.scale = function (options) {
        if (!options) {
            options = {
                animSettings: {},
                childOnElem: '',
            };
        }
        if (!options.childOnElem) {
            options.childOnElem = '';
        }
        if (!options.animSettings) {
            options.animSettings = {
                duration: anim_values_1.AnimSpeed.MEDIUM,
                scaleProps: [1, 1.2],
            };
        }
        var anim = new att_animate_1.ATTAnimate()
            .addAnim({
            animTypes: [
                anim_types_1.default.scale(options.animSettings.scaleProps),
            ],
            animationDuration: options.animSettings.duration || anim_values_1.AnimSpeed.MEDIUM,
            animationOnElem: this.animationOnElem,
        });
        return this.returnAnimState(anim);
    };
    CommonAnims.prototype.scaleFont = function (options) {
        if (!options) {
            options = {
                animSettings: {},
                childOnElem: '',
            };
        }
        if (!options.childOnElem) {
            options.childOnElem = '';
        }
        if (!options.animSettings) {
            options.animSettings = {
                duration: anim_values_1.AnimSpeed.MEDIUM,
                scaleFontProps: ['18px', '25px'],
            };
        }
        var anim = new att_animate_1.ATTAnimate()
            .addAnim({
            animTypes: [
                anim_types_1.default.scaleFont(options.animSettings.scaleFontProps),
            ],
            animationDuration: options.animSettings.duration || anim_values_1.AnimSpeed.MEDIUM,
            animationOnElem: this.animationOnElem,
        });
        return this.returnAnimState(anim);
    };
    CommonAnims.prototype.rotate = function (options) {
        if (!options) {
            options = {
                animSettings: {},
                childOnElem: '',
            };
        }
        if (!options.childOnElem) {
            options.childOnElem = '';
        }
        if (!options.animSettings) {
            options.animSettings = {
                degrees: 720,
                duration: anim_values_1.AnimSpeed.MEDIUM,
            };
        }
        var anim = new att_animate_1.ATTAnimate()
            .addAnim({
            animTypes: [
                anim_types_1.default.rotate(options.animSettings.degrees),
            ],
            animationDuration: options.animSettings.duration,
            animationOnElem: this.animationOnElem,
        });
        return this.returnAnimState(anim);
    };
    return CommonAnims;
}());
exports.default = CommonAnims;
//# sourceMappingURL=common-anims.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Animate/anim-lookups/common-anims.js
// module id = 1097
// module chunks = 8